/* NDI Collection — facet drawer toggle (tablet/mobile). Vanilla, no deps. */
(function () {
  var panel = document.getElementById('ndi-facets');
  if (!panel) return;
  var overlay = document.querySelector('.ndi-facets__overlay');
  var openBtn = document.querySelector('[data-ndi-facets-open]');

  function open() {
    panel.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    panel.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', open);
  document.querySelectorAll('[data-ndi-facets-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* Dual-handle price slider → drives the Min/Max number inputs (which submit to Shopify).
     Number inputs stay the source of truth, so filtering works with JS off. */
  document.querySelectorAll('[data-ndi-price]').forEach(function (root) {
    var max = parseFloat(root.getAttribute('data-max')) || 0;
    var sMin = root.querySelector('[data-ndi-slider-min]');
    var sMax = root.querySelector('[data-ndi-slider-max]');
    var fill = root.querySelector('[data-ndi-slider-fill]');
    var nMin = root.querySelector('[data-ndi-price-min]');
    var nMax = root.querySelector('[data-ndi-price-max]');
    if (!sMin || !sMax || !fill || !nMin || !nMax || max <= 0) return;

    function paint() {
      var lo = parseFloat(sMin.value);
      var hi = parseFloat(sMax.value);
      // Track is inset 8px (half a thumb) each side; map values into that inset span.
      var loPct = lo / max;
      var hiPct = hi / max;
      fill.style.left = 'calc(8px + ' + (loPct * 100) + '% - ' + (loPct * 16) + 'px)';
      fill.style.width = 'calc(' + ((hiPct - loPct) * 100) + '% - ' + ((hiPct - loPct) * 16) + 'px)';
    }
    function clampCross(changed) {
      var lo = parseFloat(sMin.value);
      var hi = parseFloat(sMax.value);
      if (lo > hi) { // keep handles from passing each other
        if (changed === 'min') sMin.value = hi; else sMax.value = lo;
      }
    }
    sMin.addEventListener('input', function () {
      clampCross('min');
      nMin.value = sMin.value > 0 ? sMin.value : '';
      paint();
    });
    sMax.addEventListener('input', function () {
      clampCross('max');
      nMax.value = sMax.value < max ? sMax.value : '';
      paint();
    });
    // typing in a number input moves the matching handle
    nMin.addEventListener('input', function () { sMin.value = nMin.value || 0; clampCross('min'); paint(); });
    nMax.addEventListener('input', function () { sMax.value = nMax.value || max; clampCross('max'); paint(); });

    paint();
  });
})();
